"use client";

import { IconCheckmark2Medium } from "central-icons/IconCheckmark2Medium";
import { IconCircleCheck } from "central-icons/IconCircleCheck";
import { useReadState } from "@/components/magazine/read-state";
import { Tooltip } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

export function ReadIndicator({
  className,
  variant = "icon",
}: {
  className?: string;
  variant?: "circle" | "icon";
}) {
  const icon =
    variant === "circle" ? (
      <span
        className={cn(
          "flex size-4.5 items-center justify-center rounded-full bg-gray-500 text-gray-1100",
          className
        )}
      >
        <IconCheckmark2Medium className="size-3" />
      </span>
    ) : (
      <IconCircleCheck className={cn("size-5 text-sky-500", className)} />
    );

  return (
    <Tooltip
      className="flex shrink-0 items-center justify-center"
      label="Issue marked as read"
      render={
        <span aria-label="Issue Read" role="img">
          {icon}
        </span>
      }
      sideOffset={6}
    />
  );
}

export function ReadIndicatorIfRead({
  className,
  slug,
  variant,
}: {
  className?: string;
  slug: string;
  variant?: "circle" | "icon";
}) {
  const { slugs } = useReadState();
  if (!slugs.has(slug)) {
    return null;
  }
  return <ReadIndicator className={className} variant={variant} />;
}
